// ─────────────────────────────────────────────────────────────────────────────
// "3 days" in English, "3 أيام" in Arabic.
//
// Arabic agrees with a number in SIX categories, and two of them do not take
// the numeral at all — one day is "يوم واحد", two days is "يومان". Every count
// on every screen had been built as `${n} ${t("common.days")}`, which produces
// "3 يوم" and "1 يوم": understandable, and wrong in the way that tells a reader
// the software was not written for them.
//
// `Intl.PluralRules` is the platform's own copy of the CLDR rules. It knows the
// six categories, which one 11 falls into (many, not few), and that a half day
// is "other" — so none of that is written here, where it would drift.
//
// Kept apart from the React context so the choice can be tested against the
// real dictionaries. The `days()` helper on `useI18n` is a wrapper around it.
// ─────────────────────────────────────────────────────────────────────────────

import type { Locale } from "./index";

/** The dictionary key and the numeral for a count of days, in one locale. */
export function dayCountParts(n: number, locale: Locale): {
  readonly key: `common.dayCount_${Intl.LDMLPluralRule}`;
  readonly n: string;
} {
  return {
    key: `common.dayCount_${new Intl.PluralRules(locale).select(n)}`,
    // Balances carry halves; a whole number should not be shown as "3.00".
    n: Number.isInteger(n) ? String(n) : n.toFixed(2),
  };
}
